import { RegionShared } from "@1games-ru/region-shared";
import clsx from "clsx";
import { MapPin } from "@/shared/icons";

type Props = {
  className?: string;
} & (typeof RegionShared.Cef.Requests.SetHudStateRequest)["location"];

export default function HudLocation({ className, cityName, streetName }: Props) {
  return (
    <div
      className={clsx(
        "h-[2.625rem] w-full flex items-center px-3 gap-2.5 rounded-[0.5rem] overflow-clip",
        "bg-gradient-to-r from-dark-900/60 to-dark-900/50",

        className,
      )}
    >
      <MapPin size={16} className="text-white shrink-0" />
      <div className="text-15 font-medium text-white grow overflow-hidden text-nowrap [mask-image:linear-gradient(90deg,black,rgba(0,0,0,.9),transparent)]">
        {[cityName, streetName].join(", ")}
      </div>
    </div>
  );
}
